import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function NotFound() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet - Halsnæs Epoxygulve</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="min-h-[70vh] flex items-center justify-center bg-white px-4 py-16">
        <div className="max-w-md w-full text-center space-y-6">
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-rose-50 text-rose-600 border border-rose-100">
            <i className="fa-solid fa-triangle-exclamation text-4xl"></i>
          </div>
          
          <div className="space-y-2">
            <h1 className="text-4xl font-extrabold text-brand-blue-900 tracking-tight">404 - Siden blev ikke fundet</h1>
            <p className="text-sm text-concrete-500">
              Beklager, men den side du leder efter findes ikke eller er blevet flyttet.
            </p>
          </div>

          <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center rounded-lg bg-brand-blue-900 px-6 py-3 text-sm font-bold text-white shadow-sm hover:bg-brand-blue-800"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto inline-flex items-center justify-center rounded-lg border border-concrete-200 bg-white px-6 py-3 text-sm font-bold text-brand-blue-900 hover:bg-concrete-50"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
